import { render, staticRenderFns } from "./JobReport.vue?vue&type=template&id=8bfb6708&"
import script from "./JobReport.vue?vue&type=script&lang=js&"
export * from "./JobReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports